import React, { useEffect, useState } from "react";

const PrepareTimer = ({ item }) => {
  const [time, setTime] = useState("--");

  useEffect(() => {
    const prepareLog = item?.bookingreturnprepares;

    if (!prepareLog || prepareLog.length === 0) {
      setTime("--");
      return;
    }

    const prepareTime = new Date(prepareLog[0].createdAt);

    // 🟢 If closed → static diff
    if (item.status === "query" && item?.query_date!=null ) {
     
      const closeTime = new Date(item?.query_date);
      setTime(calcDiff(prepareTime, closeTime));
      return;
   
    }
    else if (item.status === "close" && item?.close_date!=null ) {
     
      const closeTime = new Date(item?.close_date);
      setTime(calcDiff(prepareTime, closeTime));
      return;
   
    }

    // 🔴 Live timer
    const update = () => {
      setTime(calcDiff(prepareTime, new Date()));
    };

    update(); // initial call
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [
    item.status,
    item?.close_date,
    item?.bookingreturnprepares?.[0]?.createdAt
  ]);

  return <span>{time}</span>;
};

const pad = (num) => String(num).padStart(2, "0");

// helper
const calcDiff = (start, end) => {
    const diffMs = end - start;
    if (diffMs <= 0) return "00h 00m 00s";
  
    const totalSeconds = Math.floor(diffMs / 1000);
  
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

export default PrepareTimer; // ✅ IMPORTANT
